import { environment } from '../environments/environment-BUILD_TARGET_ENV'

export var EnvCode = {
    QA: 'qa',
    PROD: 'prod'
};
export var DomainCode = {
    FIDO: 'fido',
    ROGERS: 'rogers'
};

export var BrandEnvService = (function(domainCode, envCode) {
    var domain = location.hostname;
    var accountNumber;
    switch (true) {
        case domain.indexOf(DomainCode.FIDO, 0) !== -1:
            domainCode = DomainCode.FIDO;
            envCode = domain.match('www.fido.ca') ? EnvCode.PROD : EnvCode.QA;
            break;
        case domain.indexOf(DomainCode.ROGERS, 0) !== -1:
            domainCode = DomainCode.ROGERS;
            envCode = domain.match('www.rogers.com') ? EnvCode.PROD : EnvCode.QA;
            break;
        default:
            domainCode = DomainCode.FIDO;
            envCode = EnvCode.QA;
    }
    return {
        getEnvCode: function() {
            return envCode;
        },
        getDomainCode: function() {
            return domainCode;
        },
        getConfigUrl: function() {
            return environment.configBaseUrl + '/liveChat/' + domainCode + '_config.json';
        },
        getAccountNumber: function() {
            return this.accountNumber;
        },
        setAccountNumber: function(accountNumber) {
            this.accountNumber = accountNumber;
        },
        getApplicationId: function() {
            return domainCode === DomainCode.ROGERS ? 'Rogers.com' : 'Fido.ca';
        },
        getCurrentLang: function() {
            return document.cookie.replace(/(?:(?:^|.*;\s*)language\s*=\s*([^;]*).*$)|^.*$/, '$1');
        }
    };
})();